import request from '@/utils/request'
/**
 * 文件上传
 * @param url
 * @param formData
 * @param onProgress
 */
export function upload<T = unknown>(
  url: string,
  formData: FormData,
  onProgress?: (progressEvent: import('axios').AxiosProgressEvent) => void,
): Promise<T> {
  return request.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  })
}

/**
 * 文件下载
 * @param url
 * @param params
 */
export function download(url: string, params?: object, name?: string): Promise<Blob> {
  return request.post(url, params, { responseType: 'blob' }).then((response) => {
    // 创建下载链接并触发下载
    const blob = response.data as Blob
    const fileName = name ? name : `download-${Date.now()}`
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    return blob
  })
}
